import { NgxLoggerLevel } from "ngx-logger";
import { environment } from "src/environments/environment";
import { LoggingActions, LoggingActionTypes } from "./logging.actions";
import { logger } from "src/app/modules/logging/logger.reference";

export const loggingFeatureKey = "logging";

export interface LoggingState {
  level: NgxLoggerLevel;
}

export const initialLoggingState: LoggingState = {
  level: environment.defaultLogLevel,
};

export function loggingReducer(
  state = initialLoggingState,
  action: LoggingActions,
): LoggingState {
  switch (action.type) {
    case LoggingActionTypes.SetLoggingState:
      logger.debug(`STORE: ${loggingFeatureKey} set to`, action.state);
      return action.state;

    case LoggingActionTypes.SetLogLevel:
      const level = action.level;
      logger.debug(`STORE: ${loggingFeatureKey}.level set to`, level);
      return Object.assign({}, state, { level });

    default:
      return state;
  }
}
